/**
 * Notification chime for the admin (New Message Alerts setting).
 * Synthesized with WebAudio so no audio asset ships with the bundle.
 * Browsers block audio before the first user gesture — fail silent then.
 */
export function playChime(): void {
  try {
    const ctx = new AudioContext();
    const now = ctx.currentTime;

    const gain = ctx.createGain();
    gain.connect(ctx.destination);
    gain.gain.setValueAtTime(0.0001, now);
    gain.gain.exponentialRampToValueAtTime(0.08, now + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.0001, now + 0.5);

    const osc = ctx.createOscillator();
    osc.type = 'sine';
    osc.frequency.setValueAtTime(880, now); // A5
    osc.frequency.setValueAtTime(1174.66, now + 0.12); // D6
    osc.connect(gain);
    osc.start(now);
    osc.stop(now + 0.55);
    osc.onended = () => {
      void ctx.close();
    };
  } catch {
    // Audio unavailable (autoplay policy / unsupported) — alerts are best-effort.
  }
}
